module.exports = __webpack_public_path__ + "static/EstrellaMuerte-0134d851a0f6195c32b3f6d66b66839d.jpg";